<template>
    <section
        class="VibeMentorshipChoiceSection flex min-h-[672px] w-full flex-col bg-[url('@/assets/images/vibe/vibe-mentorship-choice-background.png')] max-md:max-w-full"
    >
        <div
            class="container relative flex min-h-[672px] w-full flex-col px-20 pt-24 max-md:max-w-full max-md:px-5 max-md:pt-24"
        >
            <img
                alt="Illustration of mentorship"
                class="absolute -right-4 bottom-[-18px] aspect-[1.33] w-full max-w-[200px] grow object-contain md:max-w-[250px] lg:bottom-[-21.5px] lg:max-w-[300px]"
                loading="lazy"
                src="@/assets/images/vibe/vibe-mentorship-choice-girl.svg"
            />
            <article class="relative z-10 mb-0 flex flex-col max-md:mb-2.5 max-md:max-w-full">
                <img
                    alt="Vibe logo"
                    class="aspect-[0.9] w-[18px] object-contain"
                    loading="lazy"
                    src="@/assets/images/vibe/vibe-mentorship-choice-star1.svg"
                />
                <div class="mt-8 flex w-full max-w-[1061px] flex-col self-end max-md:max-w-full">
                    <h1
                        class="ml-5 self-start text-center text-6xl font-bold leading-[62px] text-white max-md:max-w-full max-md:text-4xl max-md:leading-10"
                    >
                        Do you want to join Vibe as a mentee, mentor or both?
                    </h1>
                    <p
                        class="mt-16 self-center text-center text-2xl leading-8 text-white max-md:mt-10 max-md:max-w-full"
                    >
                        Join our growing community of good-energy enthusiasts!
                    </p>
                    <div class="mx-auto flex lg:mt-9">
                        <div
                            class="mx-auto flex min-h-[76px] gap-5 pt-5 text-center text-base leading-4 text-[#282828] max-md:mt-10 max-md:max-w-full"
                        >
                            <button
                                class="flex min-h-[56px] items-center justify-center rounded-md border border-transparent bg-[#E1C6F9] px-9 py-5 text-[#282828] shadow-[4px_4px_0px_rgba(0,0,0,1)] transition-all hover:border-black hover:shadow-none max-md:px-5"
                                @click="openMenteeForm"
                            >
                                <span class="my-auto self-stretch">I want to be a mentee</span>
                            </button>
                            <button
                                class="flex min-h-[56px] items-center justify-center rounded-md border border-transparent bg-[#FFB74D] px-9 py-5 text-[#282828] shadow-[4px_4px_0px_rgba(0,0,0,1)] transition-all hover:border-black hover:shadow-none max-md:px-5"
                                @click="openMentorForm"
                            >
                                <span class="my-auto self-stretch">I want to be a mentor</span>
                            </button>
                        </div>
                    </div>
                </div>
            </article>
        </div>

        <!-- Mentee Typeform Modal -->
        <div ref="menteeFormEmbed" class="modal-overlay" :class="{ 'modal-visible': isMenteeFormVisible }">
            <div class="absolute right-4 top-4 z-[1001]">
                <button
                    aria-label="Close form"
                    class="rounded-full bg-white dark:bg-surface-card p-2 shadow-lg hover:bg-gray-100 hover:dark:bg-subtle"
                    @click="closeMenteeForm"
                >
                    ✕
                </button>
            </div>
            <CookieIframe
                id="typeform-full"
                allow="camera; microphone; autoplay; encrypted-media;"
                class="size-full border-0"
                src="https://iz6lf50eqrh.typeform.com/to/kRh6B7SN"
            ></CookieIframe>
        </div>

        <!-- Mentor Typeform Modal -->
        <div ref="mentorFormEmbed" class="modal-overlay" :class="{ 'modal-visible': isMentorFormVisible }">
            <div class="absolute right-4 top-4 z-[1001]">
                <button
                    aria-label="Close form"
                    class="rounded-full bg-white dark:bg-surface-card p-2 shadow-lg hover:bg-gray-100 hover:dark:bg-subtle"
                    @click="closeMentorForm"
                >
                    ✕
                </button>
            </div>
            <CookieIframe
                id="typeform-full"
                allow="camera; microphone; autoplay; encrypted-media;"
                class="size-full border-0"
                src="https://iz6lf50eqrh.typeform.com/to/NUtm3IkQ"
            ></CookieIframe>
        </div>
    </section>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const isMenteeFormVisible = ref(false)
const isMentorFormVisible = ref(false)

const openMenteeForm = () => {
    isMenteeFormVisible.value = true
    document.body.style.overflow = 'hidden'
}

const closeMenteeForm = () => {
    isMenteeFormVisible.value = false
    document.body.style.overflow = 'auto'
}

const openMentorForm = () => {
    isMentorFormVisible.value = true
    document.body.style.overflow = 'hidden'
}

const closeMentorForm = () => {
    isMentorFormVisible.value = false
    document.body.style.overflow = 'auto'
}
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: white;
    z-index: 1000;
    display: none;
}

.modal-visible {
    display: block !important;
}

/* Neutral surfaces follow the selected theme; brand colors and images retain their colors. */
[data-theme="dark"] .modal-overlay {
    background: var(--color-surface-card)
}
</style>
